import {
  useController,
  type FieldValues,
  type UseControllerProps,
} from "react-hook-form";
import { Select, type ISelectProps } from "@components/inputs/Select/Select";

type TFormSelectProps<T extends FieldValues> = ISelectProps &
  UseControllerProps<T>;

export const FormSelect = <T extends FieldValues>({
  name,
  control,
  ...rest
}: TFormSelectProps<T>) => {
  const controller = useController({
    name,
    control,
  });

  const {
    field,
    fieldState: { error },
  } = controller;

  const { ref: fieldRef, ...fieldRest } = field;

  return (
    <Select
      {...rest}
      {...fieldRest}
      buttonRef={fieldRef}
      error={error?.message}
      {...(rest.disabled ? { disabled: true } : {})}
    />
  );
};
